"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodeCallData = void 0;
const viem_1 = require("viem");
const encodeCallData = async ({ args }) => {
    if (Array.isArray(args)) {
        const argsArray = args;
        return (0, viem_1.encodeFunctionData)({
            abi: [
                {
                    inputs: [
                        {
                            internalType: "address[]",
                            name: "dest",
                            type: "address[]"
                        },
                        {
                            internalType: "uint256[]",
                            name: "value",
                            type: "uint256[]"
                        },
                        {
                            internalType: "bytes[]",
                            name: "func",
                            type: "bytes[]"
                        }
                    ],
                    name: "executeBatch",
                    outputs: [],
                    stateMutability: "nonpayable",
                    type: "function"
                }
            ],
            functionName: "executeBatch",
            args: [
                argsArray.map((a) => a.to),
                argsArray.map((a) => a.value),
                argsArray.map((a) => a.data)
            ]
        });
    }
    const { to, value, data } = args;
    return (0, viem_1.encodeFunctionData)({
        abi: [
            {
                inputs: [
                    {
                        internalType: "address",
                        name: "dest",
                        type: "address"
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256"
                    },
                    {
                        internalType: "bytes",
                        name: "func",
                        type: "bytes"
                    }
                ],
                name: "execute",
                outputs: [],
                stateMutability: "nonpayable",
                type: "function"
            }
        ],
        functionName: "execute",
        args: [to, value, data]
    });
};
exports.encodeCallData = encodeCallData;
//# sourceMappingURL=encodeCallData.js.map